/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Preview_TitleInputs */

const en_start_page_preview_title = /** @type {(inputs: Start_Page_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kate Morgan · personal training`)
};

const pl_start_page_preview_title = /** @type {(inputs: Start_Page_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasia Wrona · trening personalny`)
};

/**
* | output |
* | --- |
* | "Kate Morgan · personal training" |
*
* @param {Start_Page_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_preview_title = /** @type {((inputs?: Start_Page_Preview_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Preview_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_preview_title(inputs)
	return en_start_page_preview_title(inputs)
});